import {atom} from '@tldraw/state';

/**
 * Session-only selected authors for the chart Authors strip.
 * Not persisted on the whiteboard.
 */
export const chartSelectedAuthorIdsAtom = atom('chart-selected-author-ids', []);

export function setChartSelectedAuthorIds(authorIds) {
    const next = Array.isArray(authorIds) ? authorIds.filter(Boolean) : [];
    const current = chartSelectedAuthorIdsAtom.get();
    if (current.length === next.length && current.every((id, index) => id === next[index])) {
        return;
    }
    chartSelectedAuthorIdsAtom.set(next);
}

export function toggleChartSelectedAuthorId(authorId) {
    if (!authorId) return;
    const current = chartSelectedAuthorIdsAtom.get();
    setChartSelectedAuthorIds(
        current.includes(authorId)
            ? current.filter((id) => id !== authorId)
            : [...current, authorId],
    );
}

export function clearChartSelectedAuthorIds() {
    setChartSelectedAuthorIds([]);
}
